export function subMapOf(object) {
    if (object !== null && object !== undefined) {
        if (object.hasOwnProperty('scheduleResultOfDayMap')) {
            return object.scheduleResultOfDayMap;
        } else if (object.hasOwnProperty('operationSchedulePosVoMap')) {
            return object.operationSchedulePosVoMap;
        }
    }
    return null;
}

const colors = {
    2: 'cl-purple',
    3: 'cl-blue',
    5: 'cl-deep-blue',
    6: 'cl-grad-purple-blue',
    7: 'cl-gray',
    10: 'cl-grad-purple-db',
    15: 'cl-grad-b-db',
    30: 'cl-grad-p-b-dp',
    33: 'cl-blue-d',
};

export function _colorTag(tag) {
    return colors[tag];
}